<template>
  <div class="">
    <form v-if="formStatus" class="" @submit.prevent="onSubmit">
      <form-group :validations="$v.form.name" class="w-100 my-3">
        <div slot-scope="{ errors, invalid }">
          <label>نام</label>
          <input v-model="form.name" type="text" class="form-control">
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.form.visit_limit" class="w-100 my-3">
        <div slot-scope="{ errors, invalid }">
          <label>محدودیت بازدید</label>
          <input v-model="form.visit_limit" type="text" class="form-control">
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>

      <form-group :validations="$v.form.slug" class="w-100 my-3">
        <div slot-scope="{ errors, invalid }">
          <label>
            لینک
            <b-icon icon="arrow-clockwise" @click="generateLink()"/>
          </label>
          <input v-model="form.slug" type="text" class="form-control">
          <form-errors-manager :errors="errors"/>
        </div>
      </form-group>


      <div class="text-center">
        <button type="submit" class="w-50 rounded-pill btn btn-primary">ثبت</button>
      </div>


    </form>
    <div v-else class="text-center ">

      <div class="col-12">
        <div class="row justify-content-around">
          <h5 @click="copyLink()">
            کپی لینک
            <b-icon icon="files"/>
          </h5>

          <a class="text-decoration-none text-dark" :href="fullLink" target="_blank">
            <h5>
              باز کردن لینک
              <b-icon icon="box-arrow-up-right"/>
            </h5>
          </a>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import FormGroup from "../../validator/FormGroup.vue";
import FormErrorsManager from "../../validator/FormErrorsManager.vue";
import {maxValue, minValue, numeric, required} from "vuelidate/lib/validators";
import {slug} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/VuelidateCustomValidatoins";
import {generateHash} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/ShoppingCart";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "ShareForm",
  components: {FormGroup, FormErrorsManager},
  props: {
    shareable_type: {
      default: null
    },
    shareable_id: {
      default: null
    },
    item: {},
    share: {
      default: null
    }
  },
  data() {
    return {
      form: {
        name: '',
        shareable_type: '',
        shareable_id: '',
        visit_limit: null,
        slug: null,
      },
      fullLink: null,
      formStatus: true,
    }
  },
  validations: {
    form: {
      name: {required},
      visit_limit: {numeric},
      slug: {required, slug},
    }
  },
  computed: {
    createModeStatus() {
      return this.share == null
    }
  },
  methods: {
    generateHash,
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit() {
      if (this.invalid()) {
        if (this.createModeStatus) {
          this.createShare()
        } else {
          this.updateShare()
        }
      }
    },
    generateLink() {
      this.form.slug = this.generateHash()
    },
    generateName() {
      let unix = Date.now()

      if (this.shareable_type == 'product') {
        return `${this.item.name}-${unix}`
      }

      return unix
    },
    initForm() {
      if (this.createModeStatus) {
        this.generateLink()
        this.form.name = this.generateName()
      } else {
        this.form = Object.assign({}, this.share)
      }
    },
    copyLink() {

      navigator.clipboard.writeText(this.fullLink).then(function () {
        toast('کپی با موفقیت انجام شد.', 'کپی با موفقیت انجام شد.')
      }, function (err) {
        console.log('Copy Error => ', err)
      });


    },
    createShare() {
      this.form.shareable_type = this.shareable_type
      this.form.shareable_id = this.shareable_id
      let req = this.$store.dispatch('Share/createShare', this.form)
      req.then(res => {

        let slug = res.data.data.slug;
        let routeData = this.$router.resolve({name: 'ProductShare', params: {slug: slug}});

        this.fullLink = findAttributeOnSiteInfo('site_link') + routeData.href
        this.formStatus = false

      })
    },
    updateShare() {
      this.$store.dispatch('Share/updateShare', this.form).then(res => {
        this.$emit('updateItem', this.form)
        toast('عملیات با موفقیت انجام شد.', 'عملیات با موفقیت انجام شد.')
      })
    }
  },
  mounted() {
    this.initForm()
  }
}
</script>

<style scoped>

</style>